import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { initialCursor } from '../constants';
import { useDetectClickOutsideComponent, useInternalRef } from '../../../utils';
export var useSearchBar = function useSearchBar(_ref, ref) {
  var _ref$defaultQuery = _ref.defaultQuery,
      defaultQuery = _ref$defaultQuery === void 0 ? '' : _ref$defaultQuery,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disableClearActi = _ref.disableClearAction,
      disableClearAction = _ref$disableClearActi === void 0 ? false : _ref$disableClearActi,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Search' : _ref$placeholder,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      renderItemIcon = _ref.renderItemIcon,
      error = _ref.error,
      autoFocus = _ref.autoFocus,
      onChange = _ref.onChange,
      onItemSelect = _ref.onItemSelect,
      options = _ref.options,
      groups = _ref.groups,
      _ref$suggestionListHe = _ref.suggestionListHeight,
      suggestionListHeight = _ref$suggestionListHe === void 0 ? 100 : _ref$suggestionListHe,
      _ref$enableSuggestion = _ref.enableSuggestions,
      enableSuggestions = _ref$enableSuggestion === void 0 ? true : _ref$enableSuggestion,
      additionalInfo = _ref.additionalInfo,
      renderItemAdditionalInfo = _ref.renderItemAdditionalInfo,
      restProps = _objectWithoutProperties(_ref, ["defaultQuery", "disabled", "disableClearAction", "isLoading", "placeholder", "icon", "renderItemIcon", "error", "autoFocus", "onChange", "onItemSelect", "options", "groups", "suggestionListHeight", "enableSuggestions", "additionalInfo", "renderItemAdditionalInfo"]);

  var _useState = useState(initialCursor),
      _useState2 = _slicedToArray(_useState, 2),
      cursor = _useState2[0],
      setCursor = _useState2[1];

  var _useState3 = useState(defaultQuery),
      _useState4 = _slicedToArray(_useState3, 2),
      searchQuery = _useState4[0],
      setSearchQuery = _useState4[1];

  var _useState5 = useState(!!options),
      _useState6 = _slicedToArray(_useState5, 2),
      isSuggestionsListShown = _useState6[0],
      setIsSuggestionsListShown = _useState6[1];

  var internalInputRef = useRef(null);
  var containerRef = useRef(null);
  useInternalRef(ref, internalInputRef);
  useEffect(function () {
    setIsSuggestionsListShown(!!options);
  }, [options]);
  useEffect(function () {
    setSearchQuery(defaultQuery);
  }, [defaultQuery]);

  var setIsOptionsListShown = function setIsOptionsListShown() {
    var isHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setIsSuggestionsListShown(isHidden);

    if (cursor !== initialCursor) {
      setCursor(initialCursor);
    }
  };

  useDetectClickOutsideComponent(containerRef, setIsOptionsListShown, true);
  var scrollToCurrent = useCallback(function () {
    var focused = document.querySelector('.suggestion-focused');

    if (focused) {
      focused.scrollIntoView({
        block: 'center'
      });
    }
  }, []);

  var focusOnHighlightedSuggestion = function focusOnHighlightedSuggestion() {
    return setTimeout(function () {
      return scrollToCurrent();
    }, 0);
  };

  var handleArrowDownClick = useCallback(function () {
    if (options && options.length) {
      if (!isSuggestionsListShown) {
        setIsOptionsListShown(true);
      } else {
        setCursor(function (prevState) {
          return options && prevState < (options === null || options === void 0 ? void 0 : options.length) - 1 ? prevState + 1 : 0;
        });
        focusOnHighlightedSuggestion();
      }
    }
  }, [options, isSuggestionsListShown]);
  var handleArrowUpClick = useCallback(function () {
    if (options && options.length) {
      if (!isSuggestionsListShown) {
        setIsOptionsListShown(true);
      } else {
        setCursor(function (prevState) {
          return prevState > 0 ? prevState - 1 : options.length - 1;
        });
        focusOnHighlightedSuggestion();
      }
    }
  }, [options, isSuggestionsListShown]);
  var handleEnterClick = useCallback(function () {
    if (options && options.length) {
      setSearchQuery(options[cursor].label);
      setIsSuggestionsListShown(false);

      if (onItemSelect) {
        onItemSelect(options[cursor]);
      }

      setIsOptionsListShown();
    }
  }, [options, onItemSelect, cursor]);
  var searchInputKeyHandler = useCallback(function (event) {
    var key = event.key,
        target = event.target;

    if (target === internalInputRef.current) {
      if (key === 'Escape') {
        setIsOptionsListShown();
      } else if (key === 'ArrowDown') {
        event.stopPropagation();
        handleArrowDownClick();
      } else if (key === 'ArrowUp') {
        event.stopPropagation();
        handleArrowUpClick();
      } else if (key === 'Enter' && isSuggestionsListShown) {
        handleEnterClick();
      } else if (key) {
        setIsOptionsListShown(true);
      }
    }
  }, [internalInputRef, options, isSuggestionsListShown, cursor, onItemSelect]);
  useEffect(function () {
    var _a;

    if (!disabled) {
      (_a = internalInputRef === null || internalInputRef === void 0 ? void 0 : internalInputRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', searchInputKeyHandler);
      return function () {
        var _a;

        (_a = internalInputRef === null || internalInputRef === void 0 ? void 0 : internalInputRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', searchInputKeyHandler);
      };
    }

    setSearchQuery(defaultQuery);
    return function () {};
  }, [disabled, internalInputRef, cursor, options, isSuggestionsListShown]);
  var handleChange = useCallback(function (event) {
    var _a;

    var query = ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) || '';
    setSearchQuery(query);

    if (onChange) {
      onChange(event);
    }
  }, [setSearchQuery, onChange]);
  var handleClick = useCallback(function () {
    setIsSuggestionsListShown(!!(options && options.length));
  }, [setIsSuggestionsListShown, options]);
  var handleClearQuery = useCallback(function (event) {
    event.stopPropagation();
    setSearchQuery('');

    if (onChange) {
      onChange(event);
    }
  }, [setSearchQuery, onChange]);
  var handleSuggestionClick = useCallback(function (event, suggestionIndex) {
    if (options && options.length > 0) {
      var query = options[suggestionIndex].label || '';
      setSearchQuery(query);

      if (onItemSelect) {
        onItemSelect(options[suggestionIndex]);
      }

      setIsOptionsListShown();
    }
  }, [onItemSelect]);
  var groupIndex = useMemo(function () {
    if (!groups || !groups.length) {
      return {};
    }

    return groups.reduce(function (result, group) {
      result[group.id] = group;
      return result;
    }, {});
  }, [groups]);
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: containerRef
    }),
    textInputProps: {
      disabled: disabled,
      error: error,
      onChange: handleChange,
      onClick: handleClick,
      placeholder: placeholder,
      ref: internalInputRef,
      value: searchQuery,
      wide: true,
      autoFocus: autoFocus
    },
    searchIconProps: {
      disabled: disabled,
      isLoading: isLoading
    },
    searchClearActionProps: {
      disableClearAction: disabled || disableClearAction,
      handleClearQuery: handleClearQuery,
      searchQuery: searchQuery,
      disabled: disabled
    },
    suggestionsContainerProps: {
      searchQuery: searchQuery,
      suggestionListHeight: suggestionListHeight
    },
    suggestionListContainerProps: {},
    suggestionListProps: {
      additionalInfo: additionalInfo,
      renderItemAdditionalInfo: renderItemAdditionalInfo,
      options: options,
      groups: groups,
      groupIndex: groupIndex,
      handleSuggestionClick: handleSuggestionClick,
      icon: icon,
      renderItemIcon: renderItemIcon,
      cursor: cursor,
      searchQuery: searchQuery
    },
    disabled: disabled,
    isSuggestionsListShown: isSuggestionsListShown && enableSuggestions
  };
};